
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Toca «Obre al navegador…»`,
's182ab2d6c997515f': `Afegeix-lo a la teva pantalla d'inici per a una àmplia experiència i fàcil accés.`,
's224cbcec014ef6b5': `Premeu comparteix a la barra de navegació`,
's233af3b7eb5e0364': `Afegeix a la pàgina d'inici`,
's37a9e8aec5713460': `Més`,
's4c3161035f3a1413': `Premeu el menú`,
's4e1e10a6ca408245': `Toca "Afegeix a la pantalla d'inici"`,
's6196153c4b0c1ea0': `Instal·la`,
's633502f7cff4f847': `Obre el menú del navegador`,
's681e399d63311fba': `Mostra la galeria`,
's6d14a4f70ba4e3cf': `Premeu el menú si no hi ha icona de Compartir`,
's922329d6f6213590': `Afegeix al Dock`,
's9c63a79ffcc2a3a3': `Premeu "Afegeix a la pantalla d'inici"`,
'sa2d71bfd9525168d': `Premeu "Afegeix al Dock"`,
'sa5ef80b4bb9b39f8': `Menys`,
'sb527eca1c1d7e7be': `Obre el menú del navegador integrat`,
'sba52286c21552a4e': `Instal·la'l al teu dispositiu per a una àmplia experiència i fàcil accés.`,
'sc16e00a7a8b2fde2': `Enrere`,
'scdaf4bbff76674c8': `Afegeix a pantalla d'inici`,
'sd18a5b85f599ff3c': `Obriu l'enllaç copiat al Safari`,
'se72fc3a84f9b51c3': `Toqueu per copiar l'enllaç`,
'se740f75b95a51807': `Afegeix-lo al teu Dock per a una àmplia experiència i fàcil accés.`,
'sfa6c42cdf48d93d2': `Però aquest navegador no ho admet. Obriu l'enllaç en un navegador extern per continuar.`,
'sfb78526365796a41': `Premeu "Veure'n més" al menú Compartir`,
'sfea652f6580ff086': `Aquest lloc té funcionalitats d'aplicació.`,
    };
  